module.exports = __webpack_public_path__ + "static/media/doctor-icon.5345142e.svg";